/* Plays the original Blosoma sprig animations (Lottie files in Shopify Files). Loads the player only when a page has one. */
(function () {
  var nodes = document.querySelectorAll('[data-lottie]');
  if (!nodes.length) return;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function start() {
    nodes.forEach(function (el) {
      if (el.dataset.loaded) return;
      el.dataset.loaded = '1';
      window.lottie.loadAnimation({ container: el, renderer: 'svg', loop: true, autoplay: !still, path: el.getAttribute('data-lottie') });
    });
  }
  if (window.lottie) { start(); return; }
  var s = document.createElement('script');
  s.src = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js';
  s.defer = true;
  s.onload = start;
  document.head.appendChild(s);
})();
